/*
 * Created on Mon Jun 28 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

export const images = DesktopImages();
export const mobileImages = MobileImages();
export const icons = iconImaages();
export const preloaders = preloaderImages();

function DesktopImages() {
    const items = require.context('./assets/images/desktop', false, /\.(png|jpe?g|svg)$/);
    let images = {};
    items.keys().map((item, i) => {
        return images[item.replace('./', '')] = items(item).default;
    })
    return images;
}

function MobileImages() {
    const items = require.context('./assets/images/mobile', false, /\.(png|jpe?g|svg|gif)$/);
    let images = {};
    items.keys().map((item, i) => {
        return images[item.replace('./', '')] = items(item).default;
    })
    return images;
}

function iconImaages() {
    const items = require.context('./assets/images/icons/', false, /\.(png|jpe?g|svg)$/);
    let icons = {};
    items.keys().map((item, i) => {
        return icons[item.replace('./', '')] = items(item).default;
    })
    return icons;
}

function preloaderImages() {
    const items = require.context('./assets/images/preloaders/', false, /\.(gif)$/);
    let icons = {};
    items.keys().map((item, i) => {
        return icons[item.replace('./', '')] = items(item).default;
    })
    return icons;
}

export const FlagReason = {
    PORNOGRAPHIC: 1,
    OFFENSIVE_IRRELEVANT: 2,
    INTELLECTUAL_VIOLATION: 3
}

export const UserThemes = {
    Flare: 1,
    Metro: 2
}

export const AccountTypes = {
    FashionArtist: 2,
    FashionCompany: 1,
    FashionLover: 3,
    Itch: 4
}

export const AccountTypesName = {
    [AccountTypes.FashionArtist]: 'Fashion Artist',
    [AccountTypes.FashionLover]: 'Fashion Lover',
    [AccountTypes.FashionCompany]: 'Fashion Company',
    [AccountTypes.Itch]: 'itch',
}

export const AccountTypesNameSlug = {
    [AccountTypes.FashionArtist]: 'fashion-artist',
    [AccountTypes.FashionLover]: 'fashion-lover',
    [AccountTypes.FashionCompany]: 'fashion-company',
    [AccountTypes.Itch]: 'itch',
}

export const AccountTypesSlugMapName = {
    [AccountTypesNameSlug[AccountTypes.FashionArtist]]: 'Fashion Artist',
    [AccountTypesNameSlug[AccountTypes.FashionLover]]: 'Fashion Lover',
    [AccountTypesNameSlug[AccountTypes.FashionCompany]]: 'Fashion Company'
}

export const FashionArtistProfessions = [
    {
        value: 'designer',
        label: 'Designer'
    },
    {
        value: 'photographer',
        label: 'Photographer'
    },
    {
        value: 'hairstylist',
        label: 'Hair stylist'
    },
    {
        value: 'stylist',
        label: 'Stylist'
    },
    {
        value: 'creativedirector',
        label: 'Creative director'
    },
    {
        value: 'model',
        label: 'Model'
    },
    {
        value: 'videographer',
        label: 'Videographer'
    },
    {
        value: 'makeupartist',
        label: 'Makeup artist'
    },
    {
        value: 'nailartist',
        label: 'Nail artist'
    },
    {
        value: 'retoucher',
        label: 'Retoucher'
    },
];

export const getProfessionMaps = () => {
    const professionMaps = {}
    for (const item of FashionArtistProfessions) {
        professionMaps[item.value] = item.label
    }
    return professionMaps
}

export const getProfessionsText = (user) => {
    if (!user.primaryProfession) {
        return ''
    }

    let userProfessions = [
        user.primaryProfession
    ]

    if (user.secondaryProfessions) {
        userProfessions = userProfessions.concat(user.secondaryProfessions)
    }

    const professionsMap = getProfessionMaps()
    
    return userProfessions.reduce((acc, curr, i) => {
        return acc += professionsMap[curr] + ((i + 1) < userProfessions.length ? ', ' : '')
    },'')
}

export const CompanyTypes = {
    Brand: 1,
    Service: 2,
    Agency: 3
}

export const CompanyTypesName = {
    [CompanyTypes.Brand]: 'Brand',
    [CompanyTypes.Service]: 'Service',
    [CompanyTypes.Agency]: 'Agency'
}

export const CompanyTypesNameSlug = {
    [CompanyTypes.Brand]: 'brand',
    [CompanyTypes.Service]: 'service',
    [CompanyTypes.Agency]: 'agency'
}

export const CompanyTypesSlugToName = {
    [CompanyTypesNameSlug[CompanyTypes.Brand]]: 'Brand',
    [CompanyTypesNameSlug[CompanyTypes.Service]]: 'Service',
    [CompanyTypesNameSlug[CompanyTypes.Agency]]: 'Agency'
}

export const CompanyTypesLabelSlugsList = [
    {
        value: 'brand',
        label: 'Brand'
    },
    {
        value: 'service',
        label: 'Service'
    },
    {
        value: 'agency',
        label: 'Agency'
    }
]

export const Plurals = {
    'fashion artist':'fashion artists',
    'fashion company':'fashion companies',
    'fashion lover':'fashion lovers',
    'agency':'agencies',
    'brand':'brands',
    'service':'services',
    'designer': 'designers',
    'photographer': 'photographers',
    'hair stylist': 'hair stylists',
    'stylist': 'stylists',
    'creative director': 'creative directors',
    'model': 'models',
    'videographer': 'videographers',
    'nail artist': 'nail artists',
    'makeup artist': 'makeup artists',
    'retoucher': 'retouchers',
}


export const getUserAccountCategories = ({
    accountType,
    companyType,
    primaryProfession,
    secondaryProfessions = []
}) => {
    let list = [AccountTypesName[accountType]]

    if (accountType === AccountTypes.FashionCompany) {
        list.push(CompanyTypesName[companyType])
    } else 
    if (accountType === AccountTypes.FashionArtist) {
        let professions = primaryProfession ? [primaryProfession] : []
        if (secondaryProfessions) {
            professions = professions.concat(secondaryProfessions)
        }
        list = list.concat(getProfessionLabels(professions))
    }
    return list
}

export const getUserAccountCategoriesString = ({
    accountType,
    companyType,
    primaryProfession,
    secondaryProfessions = []
}) => {
    let list = []
    if (accountType === AccountTypes.FashionCompany) {
        list.push(CompanyTypesName[companyType])
    } else 
    if (accountType === AccountTypes.FashionArtist) {
        let professions = primaryProfession ? [primaryProfession] : []
        if (secondaryProfessions) {
            professions = professions.concat(secondaryProfessions)
        }
        list = list.concat(getProfessionLabels(professions))
    }
    return [AccountTypesName[accountType], list.join(', ')].join(' / ')
}

export const CompanyTypesList = [
    {
        value: CompanyTypes.Brand,
        label: 'Brand'
    },
    {
        value: CompanyTypes.Service,
        label: 'Service'
    },
    {
        value: CompanyTypes.Agency,
        label: 'Agency'
    }
];

export const getProfessionLabels = (list) => list.map(item => {
    return FashionArtistProfessions.find(f =>  f.value === item)?.label ?? '';
})

export const getProfessionLabelValues = (list) => list.map(item => FashionArtistProfessions.find(f =>  f.value === item) ).filter(o => o !== undefined)

export const getCompanyTypeName = (ctype) => CompanyTypesList.find(c => c.value === ctype)?.label ?? ''

export const defaultAvatar = {
    FashionArtist: images['avatar_fa.png'],
    FashionCompany: images['avatar_fc.png'],
    FashionLover: images['avatar_fl.png'],
    Itch: images['itch_avatar.png']
}

export function getAccountTypeMeta(accountType, iconSize = 32) {
    let iconFlare = null;
    let iconMetro = null;
    let iconDark = null;
    let name = '';
    let slug = '';
    let fallBackAvatar = null;
    switch (accountType) {
        case AccountTypes.FashionArtist:
            iconFlare = icons[`fa-icon-${iconSize}-light.svg`];
            iconMetro = icons[`fa-icon-${iconSize}-pink.svg`];
            iconDark = icons[`fa-icon-${iconSize}-dark.svg`];
            name = 'Fashion Artist';
            slug = 'fashion-artist';
            fallBackAvatar = defaultAvatar.FashionArtist
            break;
        case AccountTypes.FashionCompany:
            iconFlare = icons[`fc-icon-${iconSize}-light.svg`];
            iconMetro = icons[`fc-icon-${iconSize}-pink.svg`];
            iconDark = icons[`fc-icon-${iconSize}-dark.svg`];
            name = 'Fashion Company';
            slug = 'fashion-company';
            fallBackAvatar = defaultAvatar.FashionCompany
            break;
        case AccountTypes.FashionLover:
            iconFlare = icons[`fl-icon-${iconSize}-light.svg`];
            iconMetro = icons[`fl-icon-${iconSize}-pink.svg`];
            iconDark = icons[`fl-icon-${iconSize}-dark.svg`];
            name = 'Fashion Lover';
            slug = 'fashion-lover';
            fallBackAvatar = defaultAvatar.FashionLover
            break;
        case AccountTypes.Itch:
            iconFlare = icons[`itch-icon-21-pink.svg`];
            iconMetro = icons[`itch-icon-21-pink.svg`];
            iconDark = icons[`itch-icon-21-pink.svg`];
            name = 'itch';
            slug = 'itch';
            fallBackAvatar = defaultAvatar.Itch
            break;
        default:
            break; 
    }
    return {
        iconFlare,
        iconMetro,
        iconDark,
        name,
        slug,
        fallBackAvatar
    }
}

export const MediaType = {
    Image: 'image',
    VideoLink: 'videoLink'
}

export const Orientation = {
    Landscape: 'l',
    Portrait: 'p'
}

export const ReviewStatus = {
    Draft: 'draft',
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
}

export const RejectReason = {
    Explicit: 'explicit',
    Legal: 'legal',
    Irrelevant: 'irrelevant',
    Unprofessional: 'unprofessional' 
}

export const RejectReasonLinks = {
    [RejectReason.Legal]: '/faq#legal-reasons',
    [RejectReason.Irrelevant]: '/faq#irrelevant-content',
    [RejectReason.Unprofessional]: '/faq#unprofessional-content',
    [RejectReason.Explicit]: '/faq#explicit-content',
}

export const Links = {
    ProtectingRights: '/here/terms#protecting-rights',
    MisUse: '/here/terms#misuse'
}

export const ActivityActions = {
    Commented : 'commented',
    CommentedArticle : 'commented_article',
    CommentedArtwork : 'commented_artwork',
    Responded : 'responded',
    RespondedArticle : 'responded_article',
    RespondedArtwork : 'responded_artwork',
    Revealed : 'revealed',
    Submitted: 'submitted',
    Wowed : 'wowed',
    Voted : 'voted',
    Itchbooked : 'itchbooked',
    UnItchbooked : 'unitchbooked',
    Viewed : 'viewed',
    Featured : 'featured',
    Followed : 'followed',
    Unfollowed : 'unfollowed',
    Tagged : 'tagged',
    TaggedArtwork : 'tagged_artwork',
    TaggedFashionStatement : 'tagged_fashion_statement',
    TaggedArtworkComment : 'tagged_artwork_comment',
    TaggedArticle : 'tagged_article',
    TaggedArticleComment : 'tagged_article_comment',
    StartedConversation : 'started_conversation',
    Approved : 'approved',
    ApprovedArtwork : 'approved_artwork',
    ApprovedArticle : 'approved_article',
    Rejected : 'rejected',
    RejectedArtwork : 'rejected_artwork',
    RejectedArticle : 'rejected_article',
    HomePaged : 'homepaged',
    Zined : 'zine',
    SharedConversation : 'shared_conversation'
}

export const ActivityTrackedSchemas = {
    Artworks : 'artworks',
    Articles : 'articles',
    Users : 'users',
    TextFashionStatement : 'fashionStatement',
    TextArtworkTitle : 'artworkTitle',
    TextArticleTitle : 'articleTitle',
    ArtworkComment : 'artworkComment',
    ArticleComment : 'articleComment'
}

export const ActivityCounterText = {
    [ActivityActions.Commented]: 'commented',
    [ActivityActions.CommentedArtwork]: 'commented',
    [ActivityActions.CommentedArticle]: 'commented',
    [ActivityActions.Responded]: 'responded',
    [ActivityActions.RespondedArticle]: 'responded',
    [ActivityActions.RespondedArtwork]: 'responded',
    [ActivityActions.Itchbooked]: 'itchbook',
    [ActivityActions.Wowed]: 'wow',
    [ActivityActions.Voted]: 'voted',
    [ActivityActions.Viewed]: 'view',
    [ActivityActions.Featured]: 'featured on zine'
}

export const Actions = {
    [ActivityActions.Commented]: 'commented by',
    [ActivityActions.CommentedArtwork]: 'commented by',
    [ActivityActions.CommentedArticle]: 'commented by',
    [ActivityActions.Responded]: 'responded by',
    [ActivityActions.RespondedArticle]: 'responded by',
    [ActivityActions.RespondedArticle]: 'responded by',
    [ActivityActions.Itchbooked]: 'itchbooked by',
    [ActivityActions.Wowed]: 'wowed by',
    [ActivityActions.Voted]: 'voted by',
    [ActivityActions.Viewed]: 'viewed by',
    [ActivityActions.Submitted]: 'submitted by',
    [ActivityActions.Revealed]: 'revealed by',
    [ActivityActions.ApprovedArtwork]: 'approved by',
    [ActivityActions.ApprovedArticle]: 'approved by',
    [ActivityActions.Approved]: 'approved by'
}

export const TaskTypes = {
    ConfirmPasswordChange: 'confirm-password-change',
    ConfirmEmailChange: 'confirm-email-change',
    PasswordReset: 'password-reset',
    Deactivate: 'deactivate'
  }

